import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";
@Component({
  selector: 'app-bar-chart-inactive-pathology-duration',
  templateUrl: './bar-chart-inactive-pathology-duration.component.html',
  styleUrls: ['./bar-chart-inactive-pathology-duration.component.css']
})
export class BarChartInactivePathologyDurationComponent implements OnInit {

            // per inizializzazione
            getAuthState: Observable<any>;
            getDoctorState: Observable<any>;
            isAuthenticated: boolean;
            user = null;
            errorMessage = null;
            subscription1: Subscription;
            subscription2: Subscription;
            subscription3: Subscription;
            subscription4: Subscription;
            subscription5: Subscription;
            subscription6: Subscription;
            title = "Durata patologia";
            destination = 'inactive';
  
            // elementi che servono per il bar-chart
            canvas: any;
            ctx: any;
            myChartInactivePatients: Chart;
      
            // ******************************************************************************************************************
            // seguenti righe: inizializzazione dei pazienti 
            // ******************************************************************************************************************
            inactiveGlobalFasciaA = 0;
            inactiveGlobalFasciaB = 0;
            inactiveGlobalFasciaC = 0;
            inactiveGlobalFasciaD = 0;
  
      
            activeGlobalFasciaA = 0;
            activeGlobalFasciaB = 0;
            activeGlobalFasciaC = 0;
            activeGlobalFasciaD = 0;
  
      
      
            GlobalPatientsFasciaA = 0;
            GlobalPatientsFasciaB = 0;
            GlobalPatientsFasciaC = 0;
            GlobalPatientsFasciaD =0;
     
      
            inactiveGlobalPatientsArray = [];
            activeGlobalPatientsArray = [];
            inactivePatientsGlobal = [];
            // ******************************************************************************************************************
            // bar chart dei pazienti 
            // ******************************************************************************************************************
            public barChartLabelsGlobalInactive = ['0-10', '10-20','20-30','30+'];
            public barChartTypeGlobalInactive = 'horizontalBar';
            public barChartLegendGlobalInactive = true;
            public barChartDataGlobalInactive = [
              {
                data: this.activeGlobalPatientsArray, label: 'Attivo', backgroundColor: ['teal', 'teal','teal', 'teal'],
                hoverBackgroundColor: ['#066', '#066','#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
              },
              {
                data: this.inactiveGlobalPatientsArray, label: 'Inattivo', backgroundColor: ['orangered', 'orangered','orangered','orangered'],
                hoverBackgroundColor: ['#cc3700', '#cc3700','cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
              }];
            
      
      
            // constructor
            constructor(private store: Store<AppState>,
                        private doctorService: DoctorService,
                        private snackBar: MatSnackBar) {
              this.getAuthState = this.store.select(selectAuthState);
              this.getDoctorState = this.store.select(selectDoctorState);
            }
            // ******************************************************************************************************************
            // metodo all'inizio
            ngOnInit(): void {
              this.subscription6 = this.getAuthState.subscribe((state) => {
                this.isAuthenticated = state.isAuthenticated;
                this.user = JSON.parse(localStorage.getItem('user'));
                this.errorMessage = state.errorMessage;
                this.retrieveGlobalInactiveFasciaA();
              });
            }
            ngOnDestroy(): void {
              this.subscription1.unsubscribe();
              this.subscription2.unsubscribe();
              this.subscription3.unsubscribe();
              this.subscription4.unsubscribe();
              this.subscription5.unsubscribe();
              this.subscription6.unsubscribe();
            }
            // ******************************************************************************************************************
            // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
            // e in standard e poi tutti
            // i pazienti in ogni categoria per poter calcolare gli attivi
            // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
    
            retrieveGlobalInactiveFasciaA() {
              this.subscription1 = this.doctorService.getInactivePathologyDurationBracketsNumber("0","10").subscribe(npatients => {
                this.inactiveGlobalFasciaA = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobalFasciaA); // riempio il vettore del bar chart con standard
                this.retrieveGlobalInactiveFasciaB();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
            retrieveGlobalInactiveFasciaB() {
              this.subscription2 = this.doctorService.getInactivePathologyDurationBracketsNumber("10","20").subscribe(npatients => {
                this.inactiveGlobalFasciaB = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobalFasciaB); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalInactiveFasciaC();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
  
            retrieveGlobalInactiveFasciaC() {
              this.subscription3 = this.doctorService.getInactivePathologyDurationBracketsNumber("20","30").subscribe(npatients => {
                this.inactiveGlobalFasciaC = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobalFasciaC); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalInactiveFasciaD();
  
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
    
            retrieveGlobalInactiveFasciaD() {
              this.subscription4 = this.doctorService.getInactivePathologyDurationBracketsNumber("30","1000").subscribe(npatients => {
                this.inactiveGlobalFasciaD = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobalFasciaD); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalPathologyDuration();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
          
            retrieveGlobalPathologyDuration() {
              this.subscription5 = this.doctorService.getGlobalPathologyDurationLoginExistsNumber().subscribe(num => {
                this.GlobalPatientsFasciaA = num[0];
                this.GlobalPatientsFasciaB = num[1];
                this.GlobalPatientsFasciaC = num[2];
                this.GlobalPatientsFasciaD = num[3];
    
                this.activeGlobalFasciaA = this.GlobalPatientsFasciaA - this.inactiveGlobalFasciaA;
                this.activeGlobalPatientsArray.push(this.activeGlobalFasciaA); // riempio il vettore del bar chart con standard           
                this.activeGlobalFasciaB = this.GlobalPatientsFasciaB - this.inactiveGlobalFasciaB;
                this.activeGlobalPatientsArray.push(this.activeGlobalFasciaB); // riempio il vettore del bar chart con telemedicina
                this.activeGlobalFasciaC = this.GlobalPatientsFasciaC - this.inactiveGlobalFasciaC;
                this.activeGlobalPatientsArray.push(this.activeGlobalFasciaC); // riempio il vettore del bar chart con standard           
                this.activeGlobalFasciaD = this.GlobalPatientsFasciaD - this.inactiveGlobalFasciaD;
                this.activeGlobalPatientsArray.push(this.activeGlobalFasciaD); // riempio il vettore del bar chart con standard           
                this.canvasSetting();
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
           
            canvasSetting() {
                this.canvas = document.getElementById('myChartInactivePathologyDuration') as HTMLCanvasElement;
                this.ctx = this.canvas.getContext('2d');
                this.myChartInactivePatients = new Chart(this.ctx, {
                  type: this.barChartTypeGlobalInactive,
                  data: {
                    labels: this.barChartLabelsGlobalInactive,
                    datasets: this.barChartDataGlobalInactive,
                  },
                  options: {
                    maintainAspectRatio: true,
                    responsive: true,
      
                    scales: {
                      xAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                      yAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                    },
                    legend: {
                     
                      display: true,
                      position: 'top',
                      labels: {
                        usePointStyle: true,
                        fontColor: '#006192',
                        fontSize: 18,
                        fontFamily: 'Helvetica',
                      }
                    },
                    tooltips: {
                      // content: '{pathology}: {number}',
                      backgroundColor: '#1c1c1c',
                      bodyFontSize: 18,
                      titleFontSize: 18,
                      cornerRadius: 5,
                      caretPadding: 10
                    },
                    title: {
                      display: true,
                      text: "N° di utenti attivi/inattivi",
                      fontColor: '#006192',
                      fontSize: 20,
                      fontFamily: 'Helvetica',
                    },
                    hover: {
                      mode: 'nearest',
                      intersect: true
                    }
                  }
                });
                } // dopo aver ottenuto tutti i dati creo il bar chart
            
          }
          